import HomePage from './HomePage.jsx';
import VisionPage from './VisionPage.jsx';
import ProductsPage from './ProductsPage.jsx';
  import HekaAtlasPage from '../pages/products/HekaAtlas.jsx'
  import HekaCodexPage from '../pages/products/HekaCodex.jsx'
  import HekaOdysseyPage from '../pages/products/HekaOdyssey.jsx'
import IntelligencePage from './IntelligencePage.jsx';
  import ArticlePage from '../pages/ArticlePage.jsx';
  import DocumentationPage from '../pages/DocumentationPage.jsx';
  import APIReferencePage from '../pages/APIReferencePage.jsx';
import CareerPage from './CareerPage.jsx';
import ConnectPage from './ConnectPage.jsx';

import ApplicationsPage from './Applications.jsx';             // HEKA PRAXIS - Later

// import JDParserPage from './JDParserPage.jsx';
// import JDParserProduct from './../products/jd-parser/JDParserProduct.tsx';
// import ResumeAnalyzerProduct from '../products/resume-analyzer/ResumeAnalyzerProduct.jsx';
// import JDCreationProduct from '../products/jd-creation/JDCreationProduct.jsx';
// import CoverLetterGeneratorApp from "../products/cover-letter/CoverLetterGeneratorApp.jsx";


export const PAGE_COMPONENTS = {
  Home: HomePage,
  'Vision & Philosophy': VisionPage,
  Products: ProductsPage,
    HekaAtlas: HekaAtlasPage,
    HekaCodex: HekaCodexPage,
    HekaOdyssey: HekaOdysseyPage,
  'Intelligence Corner': IntelligencePage,
    Article: ArticlePage,
    Documentation: DocumentationPage,
    APIReference: APIReferencePage,
  Career: CareerPage,
  Connect: ConnectPage,

  Application: ApplicationsPage,
  // JDParser: JDParserPage,
  // JDParserApp: JDParserProduct,
  // ResumeAnalyzer: ResumeAnalyzerProduct,
  // JDCreationProduct: JDCreationProduct,
  // CoverLetterGenerator: CoverLetterGeneratorApp,

};